import React from "react";
import get from "lodash/get";
import { bool, object, string } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import Excerpt from "../../atoms/Excerpt";
import StoryMetaData from "../../molecules/StoryMetaData";
import SponsorDetails from "../../molecules/SponsorDetails";

import { getExcerpt } from "../../utils/utils";

const NewsWithNoImage = ({
  story,
  showExcerpt = true,
  showDot = false,
  styles = {},
  showSubHeading = true,
  showPublishedAt = true,
  Htag,
  iconEnd = true,
  className = "",
}) => {
  const excerpt = showExcerpt ? getExcerpt(story) : "";
  const showLiveBlog = story["story-template"] === "live-blog";
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);

  const sponsor = sponsorId && !showLiveBlog;

  return (
    <div className={`news_with_no_image ${className}`} style={styles}>
      <NewsHeadline
        iconEnd={iconEnd}
        story={story}
        showDot={showDot}
        styles={styles}
        Htag={Htag}
        showSubHeading={showSubHeading}
      />

      <Excerpt excerpt={excerpt} url={story.url} />

      {sponsor ? (
        <SponsorDetails sponsorId={sponsorId} showImage={false} />
      ) : (
        <StoryMetaData story={story} isPublished={showPublishedAt} />
      )}
    </div>
  );
};

NewsWithNoImage.propTypes = {
  story: object.isRequired,
  showExcerpt: bool,
  showDot: bool,
  styles: object,
  showSubHeading: bool,
  Htag: string,
  iconEnd: bool,
  className: string,
  showPublishedAt: bool,
};

export default NewsWithNoImage;
